import script from "./workload-view-summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-summary.vue?vue&type=script&setup=true&lang=ts"

import "./workload-view-summary.vue?vue&type=style&index=0&id=6fd0f044&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd0f044"]])

export default __exports__